export const delayPromise = (time) => {
    return function (x) {
        return new Promise((resolve) => setTimeout(() => resolve(x), time));
    };
}